// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';


class CreateFixture extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      selected_one: {
        venue: '',
        game_type: '',
        game_level_id: 1,
        age_group_id: '',
        dow: 0,
        start_time: '',
        end_time: '',
        price: 200,
        fixture_name: '',
        max_sub: 30,
        batch_size: 14,
      },
      venues: [],
      game_types: [],
      data_uploaded: false,
      data_error: false,
      game_levels: [],
      age_groups: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }


  componentDidMount() {
    this.getFixtureList();
  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_types: data.game_type, game_levels: data.game_levels, age_groups: data.age_groups }))
       .catch(error => error);
  }

  postCreateFixture(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/create_fixture/`;
    const options = {...defaultOptions};
    var venue = data.venue
    var game_type = data.game_type
    if(!data.venue){venue=this.state.venues[0].id}
    if(!data.game_type){game_type=this.state.game_types[0].pk}
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'venue_id': venue,
                        'game_type_id': game_type,
                        'game_level_id': data.game_level_id,
                        'age_group_id': data.age_group_id,
                        'start_time': data.start_time,
                        'end_time': data.end_time,
                        'price': data.price,
                        'day_of_week': data.dow,
                        'fixture_name': data.fixture_name,
                        'max_sub': data.max_sub,
                        'batch_size': data.batch_size
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  dayOfWeek() {
    return [
      {id:0, name: 'Monday'},
      {id:1, name: 'Tuesday'},
      {id:2, name: 'Wednesday'},
      {id:3, name: 'Thursday'},
      {id:4, name: 'Friday'},
      {id:5, name: 'Saturday'},
      {id:6, name: 'Sunday'},
    ]
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one[name] = event.target.value
    this.setState({selected_one: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postCreateFixture(this.state.selected_one, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    console.log(this.state.selected_one);
    console.log('sucess');
    console.log(this.state);
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Create Fixture</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Batch Name
              </div>
              <input type="text" style={styles.input} name="fixture_name" className="required" value={this.state.value}
                onChange={this.handleChange} placeholder="Siemens Wednesday 6:30 - 8:00am"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Day of week
              </div>
              <select name="dow" style={styles.item_body} value={this.state.value} className="col-md-6"
                onChange={this.handleChange}>
                {
                  this.dayOfWeek().map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type
              </div>
              <select name="game_type" style={styles.item_body} className="col-md-6" value={this.state.value} onChange={this.handleChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Levels
              </div>
              <select name="game_level_id" style={styles.item_body} className="col-md-6" value={this.state.value} onChange={this.handleChange}>
                {
                  this.state.game_levels.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game.name + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group
              </div>
              <select name="age_group_id" style={styles.item_body} className="col-md-6" value={this.state.value} onChange={this.handleChange}>
                {
                  this.state.age_groups.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.abbreviation}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Time
              </div>
              <input type="text" style={styles.input} className="required" name="start_time" value={this.state.value}
                onChange={this.handleChange} placeholder="19:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Time
              </div>
              <input type="text" style={styles.input} name="end_time" className="required" value={this.state.value}
                onChange={this.handleChange} placeholder="20:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Max Subscribers
              </div>
              <input type="number" style={styles.input} name="max_sub" className="required"
                value={this.state.selected_one.max_sub} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Max Vote In
              </div>
              <input type="number" style={styles.input} name="batch_size" className="required"
                value={this.state.selected_one.batch_size} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Per Session Price
              </div>
              <input type="number" style={styles.input} name="price" className="required"
                value={this.state.selected_one.price} onChange={this.handleChange}/>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default CreateFixture;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/createFixture/index.js